import styled, { css, keyframes } from 'styled-components';
import { InputV2, ButtonV2 } from '@getgrover/ui';

import CircleCross from 'ggApp/shared/icons/CircleCross';

const FadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;
const FadeInRule = css`
    animation: ${FadeIn} 400ms linear forwards;
`;

const FadeOut = keyframes`
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;
const FadeOutRule = css`
    animation: ${FadeOut} 400ms linear forwards;
`;

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.Background};
    padding: 16px 16px 8px;
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    border-radius: 8px;
    min-height: 112px;
    margin-bottom: 8px;
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        min-height: 120px;
    `};
    flex: 0;
`;

const Title = styled.h4`
    ${({ theme }) => theme.typography.SmallHeadline};
`;

const ContentWrap = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const InputWrap = styled.div`
    flex: 0 100%;
    display: flex;
    align-items: flex-start;
    ${(props) => (props.mounted ? FadeInRule : FadeOutRule)}

    .voucherInput-input {
        padding: 4px 0 4px;
    }
`;

const InputField = styled(InputV2)`
    flex: 1;
    justify-self: flex-start;
    margin-right: 16px;
`;

const SubmitButton = styled(ButtonV2)`
    min-width: 94px;
    align-self: center;
`;

const VoucherWrap = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    ${(props) => (props.mounted ? FadeInRule : FadeOutRule)}
`;

const ResetButton = styled.div`
    cursor: pointer;
    margin-right: 8px;
    height: 32px;
`;

const ResetIcon = styled(CircleCross)`
    height: 32px;
    width: 32px;
`;

const VoucherText = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors.secondary};
`;

const VoucherCode = styled(VoucherText)`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors.secondary};
`;

const VoucherAmount = styled(VoucherText)`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors.secondary};
    margin-left: auto;
`;

const ButtonWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 12px;
`;

export {
    Wrap,
    Title,
    ContentWrap,
    InputWrap,
    InputField,
    SubmitButton,
    VoucherWrap,
    ResetButton,
    ResetIcon,
    VoucherCode,
    VoucherAmount,
    ButtonWrap,
};
